import React, { useState, useEffect } from "react";
import "./About.css";
import { Link } from "react-router-dom";
import OpacityLoading from "../Loading/OpacityLoading";
import SocialDetails from "./SocialDetails";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import AOS from "aos";
import SocialActivites from "./SocialActivities";

function About() {
  const [modalOpen, setmodalOpen] = useState(false);
  const [selectItem, setselectItem] = useState(null);
  const [skill1, setSkill1] = useState(0);
  const [skill2, setSkill2] = useState(0);
  const [skill3, setSkill3] = useState(0);
  const [skill4, setSkill4] = useState(0);

  const ToggleModal = (item) => {
    setmodalOpen(!modalOpen);
    setselectItem(item);
  };

  let socialDetail = null;
  if (modalOpen != null) {
    socialDetail = <SocialDetails item={selectItem} />;
  }

  useEffect(() => {
    let interval1 = setInterval(() => {
      if (skill1 >= 90) {
        clearInterval(interval1);
      } else {
        setSkill1(skill1 + 1);
      }
    }, 50);

    let interval2 = setInterval(() => {
      if (skill2 >= 70) {
        clearInterval(interval2);
      } else {
        setSkill2(skill2 + 1);
      }
    }, 50);

    let interval3 = setInterval(() => {
      if (skill3 >= 80) {
        clearInterval(interval3);
      } else {
        setSkill3(skill3 + 1);
      }
    }, 50);
    let interval4 = setInterval(() => {
      if (skill4 >= 75) {
        clearInterval(interval4);
      } else {
        setSkill4(skill4 + 1);
      }
    }, 50);
    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
      clearInterval(interval3);
      clearInterval(interval4);
    };
  }, [skill1, skill2, skill3, skill4]);

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <>
      <div className="about">
        <OpacityLoading>
          <div className="about-hero">
            <h1 data-aos="fade-down">My Story</h1>
          </div>

          {/* about my all description */}
          <div className="about_container">
            <div className="row my-about">
              <div className="col-md-12 col-lg-7 col-12 col-sm-12  my-5 d-flex justify-content-left align-items-center ">
                <div className="my-about-text" data-aos="fade-right">
                  <h5>my story</h5>
                  <p>
                    <span>H</span>ello, I'm Hasanul Haque Shiblu. Currently I am
                    studying Computer Science and Engineering at Daffodil
                    International University.Computer Science is my dream
                    subject and by studying this subject I am moving towards my
                    dream little by little.I have been regularly competing in
                    programming contests at my university and elsewhere.I have
                    been working on my university Embedded learning system lab
                    out of a strong desire to do research. <br /> In future I
                    would like to associate myself with more activities and
                    research work.All in all I am a calm, polite and very
                    sociable person.I always like to help people and am good at
                    making any difficult task easier through a team work.I am
                    always ready to fulfill my goals and help people.I am
                    physically and mentally feet for leading a healthy
                    cooperative and happy life.
                  </p>
                  <button>
                    <span>Download C.V</span>{" "}
                  </button>
                </div>
              </div>

              <div
                className="col-sm-12 col-12 col-md-12 col-lg-5 my-5 my-about-img"
                data-aos="zoom-in"
              >
                <img src="images/about.gif" alt="" />
              </div>
            </div>
          </div>

          {/* {skill section to easy use circular progress library} */}

          <div className="my-skill container">
            <div className="my-skill-title">
              <h4> my all experties </h4>
            </div>
            <div className="row text-center">
              <div
                className="col-sm-6 col-md-6 col-lg-3 col-12 "
                data-aos="fade-right"
              >
                <div>
                  <CircularProgressbar value={skill1} text={`${skill1}%`} />
                  <h2>Html & CSS</h2>
                </div>
              </div>
              <div
                className="col-sm-6 col-md-6 col-lg-3 col-12"
                data-aos="fade-down"
              >
                <div>
                  <CircularProgressbar value={skill2} text={`${skill2}%`} />
                  <h2> JavaScript</h2>
                </div>
              </div>
              <div
                className="col-sm-6 col-md-6 col-lg-3 col-12"
                data-aos="fade-up"
              >
                <div>
                  <CircularProgressbar value={skill3} text={`${skill3}%`} />
                  <h2>React JS</h2>
                </div>
              </div>
              <div
                className="col-sm-6 col-md-6 col-lg-3 col-12"
                data-aos="fade-left"
              >
                <div>
                  <CircularProgressbar value={skill4} text={`${skill4}%`} />
                  <h2>C</h2>
                </div>
              </div>
            </div>
          </div>

          {/* my-life childhood */}

          <div className="container-fluid">
            <div className="my-life my-5">
              <div className="row">
                <div
                  className="col-lg-8 col-md-12 col-sm-12 col-12 p-3 my-2 childhood"
                  data-aos="flip-left"
                >
                  <h2>My childhood Life</h2>
                  <p>
                    Growing up in a small village, my childhood was filled with
                    memorable moments and experiences. One of my favorite
                    memories was playing with my friends and cousins in the
                    village fields. We would spend hours running around, playing
                    games, and exploring the lush green landscape. I remember
                    one summer, we found a small pond in the fields and spent
                    the entire day swimming and splashing around. We had so much
                    fun and it was one of the most memorable days of my
                    childhood.
                    <br />
                    <br /> Another memorable moment was the annual village fair.
                    The fair was a big event in our village and everyone would
                    come out to participate. There were food stalls, games, and
                    various competitions. I remember one year, I won first prize
                    in a running race and I was so proud of myself. However, one
                    of the funniest moments from my childhood was when my cousin
                    and I decided to catch some fish from the village pond. We
                    were so determined to catch a fish that we decided to make
                    our own fishing rod out of a stick and some string. We were
                    so excited, but unfortunately, all we caught were a few
                    frogs and a snake. It was a hilarious experience and we
                    couldn't stop laughing about it for days. <br />
                    <br /> Overall, my childhood in the village was filled with
                    many fun and memorable moments that I will always treasure.
                    These experiences have shaped who I am today and have
                    instilled in me a love for nature and a sense of community.
                  </p>
                </div>
                <div className="col-lg-4  p-3  childhood-pic"></div>
                <div className="col-lg-2 p-3 m-3 web-dev-pic"></div>
                <div
                  className="col-lg-9 col-md-12 col-sm-12 col-12 p-3  web-dev"
                  data-aos="fade-left"
                >
                  <h2>Become a web developer</h2>
                  <p>
                    Becoming a web developer is a challenging yet rewarding
                    career path. It involves designing, developing and
                    maintaining websites and web applications. <br /> To become
                    a web developer, one must have a strong foundation in
                    computer science and programming languages such as HTML,
                    CSS, and JavaScript. Familiarity with popular web
                    development frameworks such as React, Angular, and Vue.js is
                    also important. It's crucial to stay updated with new
                    technologies and trends in web development. <br /> Strong
                    problem-solving and critical thinking skills, as well as
                    effective communication and collaboration skills are also
                    essential. Adaptability to change is also important as the
                    field is constantly evolving. Web developers also need to
                    have an eye for design, able to create visually appealing
                    and user-friendly websites and web applications.Another
                    important aspect of being a web developer is the ability to
                    adapt to change. The technology and trends in web
                    development change rapidly, so it's important for developers
                    to be able to learn new skills and adapt to new technologies
                    as needed. <br />
                    <br /> Overall, becoming a web developer requires a
                    combination of technical skills, creativity,
                    problem-solving, communication and adaptability.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* social activites */}

          <div className="container social">
            <div className="social-activitices-title text-center">
              <h4>Social Activities</h4>
              <p>
                I am also founder <b>THE DONORS</b> .which team all time help{" "}
                <br /> poor person in our society .{" "}
              </p>
            </div>
            <div className="social-activitices">
              <div className="row" data-aos="fade-up">
                {SocialActivites.map((item) => {
                  return (
                    <div
                      className="col-md-4 col-12 col-sm-6"
                      key={item.id}
                      onClick={() => ToggleModal(item)}
                    >
                      <div className="cards">
                        <div className="img">
                          <Link>
                            <img src={item.image} alt={item.title} />
                          </Link>
                        </div>

                        <span>
                          <h2>
                            {item.date_day}
                            <br />
                            {item.month_name}{" "}
                          </h2>
                        </span>
                        <Link>
                          <h4>{item.title} </h4>
                        </Link>
                        <Link>
                          <h3> {item.largeDescription.slice(0, 55)}...</h3>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <Modal className="my-5" isOpen={modalOpen}>
              <div className="card">
                <ModalBody>{socialDetail}</ModalBody>
              </div>

              <ModalFooter>
                <Button onClick={ToggleModal}> Cancel</Button>
              </ModalFooter>
            </Modal>
          </div>
        </OpacityLoading>
      </div>
    </>
  );
}

export default About;
